<topmenu></topmenu>
<app-toasts></app-toasts>
<drawer [lang]="preferredlanguage"></drawer>
<div class="min-h-screen bg-e-white">
    <router-outlet>
    </router-outlet>
</div>


